import React, {useEffect, useState} from "react";
import {Box, Button, Typography, useMediaQuery} from "@mui/material";
import {makeStyles} from "@mui/styles";
import {AsyncImageWithLoader} from "../../../com/imageWithLoader/imageWithLoader";
import uploadPdfIcon from "./../../../assets/xCircularIcons/uploadPdfIcon.png"
import {createFlyerFromPdfFile} from "../../../store/actionCreators/flyerFromPdfActionCreator";
import {useDispatch} from "react-redux";
import {ProgressBarWithLabel} from "../../editor/progressBar/progressBar";
import {LoginDto, UploadProgressingImagesDto, UserDto} from "../../../dtos";
import {HttpTransportType, HubConnectionBuilder, IHttpConnectionOptions, LogLevel} from "@microsoft/signalr";
import envManager from "../../../com/envManager/EnvManager";
import {PageSpinner} from "../../com/pagesTab/pagesSpinner/spinner";
import {useTypedSelector} from "../../../hooks/useTypeSelector";
import {updateFlyerDetailsPageImageState} from "../../../store/actionCreators/flyerDetailsActionCreators";
import {actionCreators, getFlippingFlyer} from "../../../store";
import {
    changeUploadingImagesProgressPopup,
    startUploadingImagesProgressPopup
} from "../../../store/actionCreators/uploadingImagesProgressActionCreator";
import {formatBytes} from "../../../globals/globalFunctions";

const useStyles = makeStyles(() => ({
    uploadingPdfWrapper: {
        display: `flex`,
        width: `100%`,
        height: `100vh`,
        backgroundColor: `#ffffff`,
    },

    uploadButtonWrapper: {
        display: `flex`,
        alignItems: `end`
    },
    uploadButton: {
        '&.MuiButtonBase-root': {
            padding: `10px 0`,
            // height: `100%`,
            flex: `1 1 auto`,
            // width: `100%`,
            // height: `64px`,
            display: `flex`,
            alignItems: `center`,
            justifyContent: `center`,
            border: `2px dashed #161B7E`,
            borderRadius: `0`,
            boxShadow: `none`,
            backgroundColor: `#F9F9FF`,
            width: `100%`,
            height: `220px`,
            maxHeight: `50vh`,
            flexFlow: `column`,
            color: `inherit`,

            '&:hover': {
                backgroundColor: `#F9F9FF`,
                boxShadow: `none`
            }
        }
    },
    loaderWrapper: {
        display: `flex`,
        justifyContent: `center`,
        alignItems: `center`,
        height: `100%`
    },
    uploadingProgressBarWrapper: {
        width: `100%`,
        height: `100%`,
        display: `flex`,
        flexFlow: `column`,
        justifyContent: `space-between`,
        padding: `30px`,
    },
    flyerPreviewWrapper: {
        flex: `1 1 auto`,
        backgroundColor: `#ffffff`,
        display: `flex`,
        justifyContent: `flex-end`
    },
    flyerPreview: {
        maxHeight: `100%`,
        maxWidth: `100%`,
        position: `relative`,
    }

}));

interface UploadingStateDto {
    isShowProgressBar: boolean;
    isPagesUploading: boolean;
    pdfFile: null | File;
    pdfFileSizeMb: string;
}

interface PagesStateDto {
    currentPageNumber: number;
    totalPageNumber: number;
}

const defaultUploadingState: UploadingStateDto = {
    isShowProgressBar: false,
    isPagesUploading: false,
    pdfFile: null,
    pdfFileSizeMb: ''
}

const defaultPagesState: PagesStateDto = {
    currentPageNumber: 0,
    totalPageNumber: 0,
}


export const UploadingPdfAndCreateFlyer = () => {
    const flyerDetailsState = useTypedSelector((state) => state.flyerDetails);
    const flyerDataFromPdf = useTypedSelector((state) => state.flyerDataFromPdf);
    const userDataInfo = useTypedSelector((state) => state.auth);
    const uploadData = useTypedSelector((state) => state.uploadImagesPopup);
    const isSm = useMediaQuery(`(max-width:899px)`);
    const classes = useStyles();
    const dispatch = useDispatch();
    const [uploadingState, setUploadingState] = useState<UploadingStateDto>(defaultUploadingState);
    const [pagesState, setPagesState] = useState<PagesStateDto>(defaultPagesState);
    const [isProcessingFinished, setProcessingFinished] = useState<boolean>(false);
    const [userData, setUserData] = useState<UserDto>();
    const [lang, setLang] = useState<'he' | 'en-US'>('en-US')

    //signalR start

    const [connection, setConnection] = useState<any>(null);

    /*
        const optionsSignal: IHttpConnectionOptions = {
            accessTokenFactory: () => {
                return userDto.token;
            },
            skipNegotiation: true,
            transport: HttpTransportType.WebSockets
        };
    */

    useEffect(() => {
        if (userDataInfo.type === 'LOGIN_SUCCESS') {
            let userDtoStr = localStorage.getItem("userDtoForPreview");
            let userDto: UserDto = JSON.parse(userDtoStr!);
            setUserData(userDto);
        }
    }, [userDataInfo.type]);

    useEffect(() => {
        setProcessingFinished(uploadData.processingFinished)
        if (uploadData.processingFinished) {
            setPagesState(defaultPagesState);
        } else {
            setPagesState({
                currentPageNumber: uploadData.current,
                totalPageNumber: uploadData.total,
            });
        }

    }, [uploadData])

    useEffect(() => {
        if (userData?.token) {
            console.log(userData.token);
            const optionsSignal: IHttpConnectionOptions = {
                accessTokenFactory: () => {
                    return userData.token;
                },
                skipNegotiation: true,
                transport: HttpTransportType.WebSockets
            };

            if (connection === null) {
                const newConnection = new HubConnectionBuilder()
                    .withUrl(`${envManager.flyerEditorServerAddress}/xceditor-hub`, optionsSignal)
                    .configureLogging(LogLevel.Information)
                    .withAutomaticReconnect()
                    .build()
                setConnection(newConnection);
            }

        }
    }, [userData]);


        useEffect(() => {
            const onGetResponse = (event: MessageEvent) => {
                // IMPORTANT: check the origin of the data!
                if (event.origin === 'https://www.xcircular.com') {
                // if (event.origin === 'https://xcircular.com') {
                    setLang(event.data.lang);
                    // The data was sent from your site.
                    // Data sent with postMessage is stored in event.data:
                    // if (event?.data?.userData) {
                    //     setUserData(event.data.userData);
                    //     localStorage.setItem('userDto', JSON.stringify(event.data.userData));
                    // } else {
                    //     let loginDto: LoginDto = {
                    //         emailAddress: `marketing@xcircular.com`,
                    //         password: `a1b2c3d4e5f6`
                    //     }
                    //     dispatch(actionCreators.login(loginDto));
                    // }

                } else {
                    // The data was NOT sent from your site!
                    // Be careful! Do not use it. This else branch is
                    // here just for clarity, you usually shouldn't need it.
                    return;
                }

            }
            window.addEventListener('message', onGetResponse);
            return () => {
                window.removeEventListener('message', onGetResponse);
            }
        }, []);

    useEffect(() => {
        try {
            let currentFlyerStatus = flyerDetailsState.flyFstRec;
            let statusCaption = currentFlyerStatus.fstCaption?.toLowerCase()

            let appUrl = '';

            if (statusCaption?.includes('edit')) {
                appUrl = envManager.getFlyerAppAddressWithEnvPrefix('dev')
            } else if (statusCaption?.includes('qa')) {
                appUrl = envManager.getFlyerAppAddressWithEnvPrefix('qa')
            } else if (statusCaption?.includes('published')) {
                appUrl = envManager.getFlyerAppAddressWithEnvPrefix('')
            }

            //
            if (appUrl.length !== 0 && flyerDetailsState.flyRecId) {
                let accountName = flyerDetailsState.flyAccRec?.accCaption;
                let flyerName = flyerDetailsState.flyCaption;
                appUrl += `flipbook/${accountName}/${flyerName}`
            }

            if (statusCaption?.includes('inactive')) {
                appUrl = ''
            }

            // Any way if the current flyer has no job code (RecId) => no flyer app address to show
            if (!flyerDetailsState.flyRecId) {
                appUrl = ''
            }
            if (window.location !== window.top.location && appUrl !== '') {
                window.top.postMessage({
                    url: appUrl,
                    fileName: uploadingState.pdfFile?.name || ""
                }, 'https://www.xcircular.com')
                // window.top.postMessage({
                //     url: appUrl,
                //     fileName: uploadingState.pdfFile?.name || ""
                // }, 'https://xcircular.com')
            }
            setUploadingState(defaultUploadingState);

            // if (flyerDetailsState.flyFstRec.fstCaption === "Published" && flyerDetailsState.qualificationLevel === 0) {
            //     setDisabledOpen(true);
            // }
        } catch (e) {
            console.log(e);
        }

    }, [flyerDetailsState.flyFstRec, flyerDetailsState.flyRecId])


    useEffect(() => {
        //start with default flyer
        // dispatch(getFlippingFlyer(418));
        // const userDto = localStorage.getItem('userDtoForPreview');
        // if(!userDto){
        let loginDto: LoginDto = {
            // emailAddress: `support@xcircular.com`,
            // password: `123456`
            // emailAddress: `johndoe@gmail.com`,
            // password: `123456`
            emailAddress: `marketing@xcircular.com`,
            password: `a1b2c3d4e5f6`
        }
        dispatch(actionCreators.login(loginDto, true));
        // }

    }, []);


    useEffect(() => {
        if (isProcessingFinished && flyerDataFromPdf.flyerId) {
            dispatch(getFlippingFlyer(Number(flyerDataFromPdf.flyerId), undefined, true));
            setProcessingFinished(false);
        }
    }, [isProcessingFinished])

    useEffect(() => {
        if (connection) {
            connection.keepAliveIntervalInMilliseconds = 1000 * 60 * 3;
            connection.serverTimeoutInMilliseconds = 1000 * 60 * 6;
            connection.start().catch((e: any) => {
                console.log('Connection failed: ', e)
            });
            connection.on('UploadPageImagesResponse', (message: any) => {
                const data: UploadProgressingImagesDto = {
                    isUploadingFilesToSystem: false,
                    isUploadingFilesToSystemFinished: true,
                    current: message.current,
                    failCount: message.failCount,
                    processingFinished: message.processingFinished,
                    successCount: message.successCount,
                    severityLevel: message.response.severityLevel,
                    total: message.total,
                    titlePopup: message.response.userFriendlyMessage,
                    notUploadedImages: message.response.severityLevel.toString().toLowerCase() === 'error' ? [{
                        imageFileName: message.response.data[0].value,
                        message: message.response.userFriendlyMessage
                    }] : null,
                }
                dispatch(changeUploadingImagesProgressPopup(data))
                dispatch(updateFlyerDetailsPageImageState({
                    pageId: message.data?.pageId,
                    imageUrl: message.data?.imageUrl,
                    imageThumbnailUrl: message.data?.thumbnailUrl
                }));
                console.log(`signalR response "UploadPageImagesResponse event":`);
                console.log(message);
            });
        }
    }, [connection]);

    //signalR end
    /*
        useEffect(() => {
            //signalR start
            if (connection === null) {
                const newConnection = new HubConnectionBuilder()
                    .withUrl(`${envManager.flyerEditorServerAddress}/xceditor-hub`, optionsSignal)
                    .configureLogging(LogLevel.Information)
                    .withAutomaticReconnect()
                    .build()
                setConnection(newConnection);
            }
            //signalR end
        }, []);
    */

    useEffect(() => {
        if (flyerDataFromPdf.type === 'CREATE_FLYER_FROM_PDF_ERROR') {
            setUploadingState(defaultUploadingState);
            setPagesState(defaultPagesState);
        }
    }, [flyerDataFromPdf])


    const onFileSelected = (event: React.ChangeEvent<HTMLInputElement>) => {
        const file = event.target.files![0];
        setUploadingState({
            isShowProgressBar: true,
            isPagesUploading: true,
            pdfFile: file,
            pdfFileSizeMb: formatBytes(file.size)
        })
        dispatch(startUploadingImagesProgressPopup());
        dispatch(createFlyerFromPdfFile(file, true));
    }


    return (
        <Box
            className={classes.uploadingPdfWrapper}
            sx={{
                flexFlow: isSm ? `column` : `row`,
                overflow: isSm ? `auto` : `hidden`
            }}
        >
            <Box
                className={classes.uploadButtonWrapper}
                sx={{
                    width: isSm ? `100%` : `40%`,
                    height: isSm ? `220px` : `100%`,
                }}
            >
                <Button
                    variant="contained"
                    component="label"
                    className={classes.uploadButton}
                >
                    {
                        uploadingState.isPagesUploading && uploadingState.isShowProgressBar && pagesState.totalPageNumber === 0 &&
                        <Box
                            className={classes.loaderWrapper}
                        >
                            <PageSpinner/>
                        </Box>

                    }
                    {
                        uploadingState.isPagesUploading && uploadingState.isShowProgressBar && pagesState.totalPageNumber > 0 && uploadingState.pdfFile &&
                        <Box
                            className={classes.uploadingProgressBarWrapper}
                        >
                            <Box
                                sx={{
                                    display: `flex`, alignItems: `center`, justifyContent: `space-between`
                                }}
                            >
                                <Typography>
                                    {Number(Math.floor((pagesState.currentPageNumber * 100) / pagesState.totalPageNumber))}%
                                    {uploadData.isUploadingFilesToSystem ? ' Uploading file' : ' Creating pages'}
                                </Typography>
                                <Typography>
                                    {uploadingState.pdfFileSizeMb ? uploadingState.pdfFileSizeMb : `test mb`}
                                </Typography>
                            </Box>
                            <ProgressBarWithLabel withLabel={false}
                                                  value={Number(Math.floor((pagesState.currentPageNumber * 100) / pagesState.totalPageNumber))}/>
                            <Box>
                                {uploadData.isUploadingFilesToSystem &&
                                    <Typography>
                                        {uploadingState.pdfFile?.name ? uploadingState.pdfFile.name : `test mb`}
                                    </Typography>
                                }
                                {!uploadData.isUploadingFilesToSystem &&
                                    <Typography>
                                        {uploadData.current}/{uploadData.total} pages created
                                    </Typography>
                                }
                            </Box>
                        </Box>
                    }
                    {
                        !uploadingState.isPagesUploading &&
                        <>
                            <img src={uploadPdfIcon} alt=""/>
                            <Typography color={`#ffffff`} m={`10px`} p={`10px`} bgcolor={`#161B7E`} borderRadius={`5px`} fontSize={`18px`} dir={lang === 'he' ? `rtl` : `ltr`}>
                                {lang === 'he' ? `העלאת קובץ PDF` : 'Upload PDF File'}
                            </Typography>
                            <input
                                type="file"
                                accept={`.pdf`}
                                multiple={false}
                                onChange={onFileSelected}
                                hidden
                            />
                        </>
                    }
                </Button>
            </Box>
            <Box
                className={classes.flyerPreviewWrapper}
                sx={{
                    // marginTop: isSm ? `20px` : `0`
                }}
            >
                <Box
                    className={classes.flyerPreview}
                    sx={{
                        width: isSm ? `100vw` : `auto`,
                        // minWidth: `40%`
                    }}
                >
                    {/*
                    <Button sx={{
                        position: `absolute`,
                        width: `140px`,
                        height: `140px`,
                        top: '50%',
                        left: isSm ? `50%` : `0`,
                        transform: 'translate(-50%, -50%)',
                        display: `flex`,
                        alignItems: `center`,
                        justifyContent: `center`,
                        flexFlow: `column`,
                        borderRadius: `50%`,
                        backgroundColor: `#161B7E`,
                        color: `initial`,
                        '&:hover': {
                            backgroundColor: `#444897`,

                        }
                    }}>
                        <FlyerIcon/>
                        <Typography color={`#ffffff`}>
                            Preview
                        </Typography>
                    </Button>
*/}
                    <AsyncImageWithLoader
                        src={flyerDetailsState.flyerPages.length && flyerDetailsState.flyerPages[0].flpImageUrl ? flyerDetailsState.flyerPages[0].flpImageUrl : `https://stgxcircular.blob.core.windows.net/dev/accounts/4/flyers/418/pages/8780/Shopper Flyer_1.jpg?84f60643-4b11-4e1d-b66c-cc2eff80b222`}/>
                </Box>
            </Box>
        </Box>
    )
}